import * as React from "react";
import {
  Img,
  Heading,
  Link,
  Row,
  Section,
  Text,
  Button,
  Column,
} from "@react-email/components";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";

export const name = "WaitlistBuyOrderCreated";
export const subject = "You're on the waitlist list for {{event_name}}";

export function template(props: {
  event_name: string;
  organization_logo: string;
  first_name: string;
  event_url: string;
  dashboard_url: string;
  cdn_url: string;
  event_image: string;
  wallet_url: string;
}) {
  return (
    <Layout language="en" title={`${props.event_name} is live. `}>
      <Header src={props.event_image} />
      <Heading as="h1" style={{ fontSize: "30px", color: "black" }}>
        Hey {props.first_name},
      </Heading>
      <Heading as="h1" style={{ fontSize: "30px", color: "black" }}>
        You're on the waitlist for: {props.event_name}
      </Heading>
      <Section>
        <Row>
          <Text style={style.bodyText}>
            We will notify you via email if we get tickets for you.{" "}
            <Text style={style.bold}>You card has not been charged yet.</Text>
          </Text>
        </Row>
        <Row>
          <Text style={style.bodyText}>
            You can view your waitlist status below at any time.
          </Text>
        </Row>
        <Row style={{ textAlign: "center", marginTop: "10px" }}>
          <Column>
            <Button
              href={props.wallet_url || props.event_url}
              style={{
                backgroundColor: "black",
                borderRadius: "45px",
                fontWeight: "bold",
                letterSpacing: "6px",
                padding: "15px 20px",
                color: "white",
                fontSize: "14px",
                margin: "0 auto",
                border: "1px solid white",
              }}
            >
              VIEW WAITLIST STATUS
            </Button>
          </Column>
        </Row>
      </Section>
      <Footer cdn_url={props.cdn_url} />
    </Layout>
  );
}

const style: Record<string, React.CSSProperties> = {
  bold: {
    display: "inline",
    fontSize: "18px",
  },
  bodyText: {
    fontSize: "18px",
    lineHeight: "22px",
    color: "black",
  },
};

template.PreviewProps = {
  event_name: "Test event",
  first_name: "David",
  event_url:
    "https://coachella.kydlabsdemo.com/e/EV3cfb122a-277b-4c93-9b8d-f8003a015a38/cart?cko-session-id=sid_p5bnqz263kvevpy4ibb7kgrcye",
  dashboard_url:
    "https://coachella.kydlabsdemo.com/manager/events/EV2f1de93f-17d7-4881-a2ff-c083c580dbdc",
};

export default template;
